import 'date-fns';
import React, { useEffect } from 'react';
import PropTypes from "prop-types";
import Grid from '@mui/material/Grid';
import DateFnsUtils from '@date-io/date-fns';
import ptBRLocale from 'date-fns/locale/pt-BR'
import { backdropClasses, TextField, Tooltip } from "@mui/material";
import { FormattedMessage, injectIntl } from 'react-intl';


//import { DatePicker } from '@mui/x-date-pickers/DatePicker';
//import LocalizationProvider from '@mui/lab/LocalizationProvider';
//import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';


function MaterialUIPickerInlineRequired(props) {

    const intl = props.intl;

    const { label, stateName, changeDate, onChange, currentDate, format = 'dd/MM/yyyy', fullWidth, minDate = null, disabled = false, required = false, toolTipTitle = "" } = props;

    const [selectedDate, setSelectedDate] = React.useState();


    React.useEffect(() => {
        setSelectedDate(currentDate);
    }, [currentDate]);

    const handleDateChange = date => {
        setSelectedDate(date);
        if (changeDate != null) {
            changeDate(stateName, date);
        }
        else {
            if (onChange != null) {
                onChange(stateName, date);
            }
        }
    };

    const today = new Date();

    useEffect(() => {
        if (fullWidth) {
            setTimeout(() => {
                const element = document.getElementsByClassName('date-picker-inline')[0];
                if (element) {
                    element.style.width = '100%';
                    element.style.background = 'white';
                }
            }, 100);
        }
    });

    return (
        <LocalizationProvider utils={DateFnsUtils} locale={ptBRLocale} dateAdapter={AdapterDateFns}>
            <Grid container justify="space-around">
                <DatePicker
                    className="date-picker-inline"
                    renderInput={(props) => {
                        if (toolTipTitle) {
                            return (
                                <Tooltip
                                    title={label || ""}
                                    arrow
                                    placement="top"
                                    enterDelay={500}
                                    leaveDelay={200}
                                >
                                    <TextField {...props} required={required} disabled={disabled} />
                                </Tooltip>
                            )
                        }

                        return (
                            (
                                <TextField {...props} required={required} disabled={disabled} />
                            )
                        )

                    }}
                    inputFormat={format}
                    disableToolbar
                    variant="inline"
                    format={format}
                    label={label}
                    value={selectedDate}
                    invalidDateMessage={intl.formatMessage({ id: "date.pickers.invalid.date" })}
                    minDateMessage={intl.formatMessage({ id: "date.pickers.date.error" })}
                    onChange={handleDateChange}
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                    minDate={minDate}
                    disabled={disabled}
                    required={required}
                />
            </Grid>
        </LocalizationProvider>
    );
}

MaterialUIPickerInlineRequired.propTypes = {
    label: PropTypes.string,
    stateName: PropTypes.string,
    changeDate: PropTypes.func,
    currentDate: PropTypes.string,
    format: PropTypes.string,
    minDate: PropTypes.object,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    toolTipTitle: PropTypes.string
};

export default injectIntl(MaterialUIPickerInlineRequired);